import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Field } from "@/lib/ui";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const CATEGORIES = [["exam", "Examen"], ["quiz", "Quiz"], ["project", "Projet"], ["participation", "Participation"], ["extra_credit", "Bonus"]];

export function ExamSubjectPicker({ f, setF, canType }) {
  const [subjects, setSubjects] = useState([]);
  const [manual, setManual] = useState(!!f.subject_manual);
  useEffect(() => {
    if (!f.class_id) { setSubjects([]); return; }
    api.get(`/subjects?class_id=${f.class_id}`).then(setSubjects).catch(() => setSubjects([]));
  }, [f.class_id]);
  const cur = subjects.find((s) => s.id === f.subject_id);
  const subs = cur?.sub_subjects || [];
  const toggleManual = (on) => { setManual(on); setF({ ...f, subject_manual: on, subject_id: null, sub_subject: null, subject: on ? (f.subject || "") : "" }); };

  return (
    <>
      <Field label="Matière">
        {manual ? (
          <Input value={f.subject || ""} onChange={(e) => setF({ ...f, subject: e.target.value })} placeholder="Saisir la matière" data-testid="exam-subject-input" />
        ) : (
          <Select value={f.subject_id || ""} onValueChange={(v) => { const s = subjects.find((x) => x.id === v); setF({ ...f, subject_id: v, subject: s?.name || "", sub_subject: null }); }} disabled={!f.class_id}>
            <SelectTrigger data-testid="exam-subject-select"><SelectValue placeholder={f.class_id ? (subjects.length ? "Choisir une matière" : "Aucune matière pour cette classe") : "Choisissez d'abord la classe"} /></SelectTrigger>
            <SelectContent>{subjects.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}</SelectContent>
          </Select>
        )}
        {canType && <label className="mt-1 flex items-center gap-1.5 text-xs cursor-pointer"><input type="checkbox" checked={manual} onChange={(e) => toggleManual(e.target.checked)} data-testid="exam-subject-manual" />Saisir la matière à la main</label>}
      </Field>
      {!manual && subs.length > 0 && (
        <Field label="Sous-matière">
          <Select value={f.sub_subject || ""} onValueChange={(v) => setF({ ...f, sub_subject: v })}>
            <SelectTrigger data-testid="exam-subsubject-select"><SelectValue placeholder="Choisir une sous-matière" /></SelectTrigger>
            <SelectContent>
              {subs.map((s) => <SelectItem key={s.name} value={s.name}>{s.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </Field>
      )}
      <Field label="Catégorie de note">
        <Select value={f.category || (f.type === "official" || f.type === "admission" ? "exam" : "quiz")} onValueChange={(v) => setF({ ...f, category: v })}>
          <SelectTrigger data-testid="exam-category-select"><SelectValue /></SelectTrigger>
          <SelectContent>{CATEGORIES.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
        </Select>
      </Field>
    </>
  );
}
